import { combineReducers } from "redux";
import { resources } from "./resources";
import { loGet } from "../../utils/alias";

const user = (state = {}, action) => {
    switch (action.type) {
        case "USER_FOUND":
            return {
                ...state,
                auth: action.user
            };
        case "UPDATE_USER":
        case "GET_CURRENT_USER_RESPONSE":
            if (!action.user) {
                return state;
            }
            const { auth, ...newUserDetails } = action.user;
            return {
                ...state,
                ...newUserDetails
            };
        case "NO_USER_FOUND":
        case "LOGOUT":
            return {};
        default:
            return state;
    }
};

const notifications = (state = {}, action) => {
    switch (action.type) {
        case "ADD_NOTIFICATION":
            return {
                ...state,
                [action.notification.id]: action.notification
            };
        case "REMOVE_NOTIFICATION":
            const { [action.id]: removed, ...others } = state;
            return others;
        default:
            return state;
    }
};

const permissions = (state = {}, action) => {
    switch (action.type) {
        case "GET_PERMISSIONS_RESPONSE":
            return action.permissions ? action.permissions : state;
        default:
            return state;
    }
};

const formError = (state = {}, action) => {
    switch (action.type) {
        case "FORM_FAIL":
            return action.formError;
        case "EXIT_FORM":
            return {};
        default:
            return state;
    }
};

const userSubjects = (state = {}, action) => {
    switch (action.type) {
        case "GET_USER_SUBJECTS_RESPONSE":
            return action.userSubjects;
        default:
            return state;
    }
};

const articles = (state = {}, action) => {
    switch (action.type) {
        case "GET_ARTICLES_RESPONSE":
            return action.articles || {};
        default:
            return state;
    }
};

const appReducer = combineReducers({
    formError,
    notifications,
    permissions,
    user,
    resources,
    articles,
    userSubjects
});

const rootReducer = (state = {}, action) => {
    if (action.type === "LOGOUT") {
        const persistOnLogout = {};
        return appReducer(persistOnLogout, {});
    }
    return appReducer(state, action);
};

const selectUser = state => loGet(state, ["user"]);
const userAuthData = state => loGet(selectUser(state), ["auth"]);
const selectPosition = state => loGet(selectUser(state), "position");
const isUserCreationCompleted = selectPosition;
const selectUid = state => loGet(userAuthData(state), "uid");
const isLoggedIn = state => !!selectUid(state);

const email = state => loGet(userAuthData(state), ["email"]);
const displayName = state => loGet(selectUser(state), ["displayName"]);
const isAdmin = state => loGet(state, ["permissions", "admin"]);

const formErrorMessage = state => state.formError.message;

const resourceLoaded = resourceName => state => !state.resources[resourceName];
const userLoaded = state =>
    resourceLoaded("USER")(state) &&
    (isLoggedIn(state) ? !!isUserCreationCompleted(state) : true);
const permissionsLoaded = resourceLoaded("PERMISSIONS");
const userSubjectsLoaded = resourceLoaded("USER_SUBJECTS");

const allLoaded = state =>
    userLoaded(state) && permissionsLoaded(state) && userSubjectsLoaded(state);

const appNotifications = state => state.notifications;

const userSubject = id => state => loGet(state, ["userSubjects", id], {});
const selectArticles = state => loGet(state, ["articles"], {});
const articleIds = state => Object.keys(selectArticles(state));
const articleForId = id => state => loGet(selectArticles(state), [id], {});

export {
    allLoaded,
    appNotifications,
    displayName,
    email,
    formErrorMessage,
    isAdmin,
    isLoggedIn,
    permissionsLoaded,
    rootReducer,
    selectUid,
    selectUser,
    userLoaded,
    userSubject,
    articleIds,
    articleForId
};



// WEBPACK FOOTER //
// ./src/store/reducers/index.js